import { CSSProperties, useEffect, useState } from 'react';

import { OverlayData } from 'types';
import { classes, ImageLoader } from 'utils';
import { mediaSizeSetup } from './helpers';

import styles from './TriggerContent.module.scss';

type Props = {
  expUrl: string;
  name: string;
  logoUrl: string;
  status: 'active' | 'closed';
  interactionId: string;
  mode: string;
  onLoad: () => void;
  onAction: (action: OverlayData) => void;
};

const TriggerContent = (props: Props) => {
  const { name, logoUrl, status, onLoad } = props;
  const { interactionId: id, mode, expUrl: url, onAction } = props;

  const [style, setStyle] = useState<CSSProperties>();

  useEffect(() => {
    if (logoUrl) {
      const loader = new ImageLoader(logoUrl, (w, h) => {
        setStyle(mediaSizeSetup(w, h));
        onLoad();
      });

      return () => loader.cancel();
    }

    onLoad();
  }, [logoUrl, onLoad]);

  return style ? (
    <div
      className={classes(styles.trigger, styles[status])}
      style={{ width: style.width, maxWidth: style.maxWidth }}
      onClick={
        status === 'active'
          ? () => onAction({ type: 'interaction', payload: { id, mode, url } })
          : undefined
      }
    >
      <div className={styles.banner} style={style}>
        <img width={style.width} height={style.height} src={logoUrl} alt="" />
      </div>

      <span className={styles.text}>{name}</span>
    </div>
  ) : null;
};

export default TriggerContent;
